import {Card} from 'platform/components';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {CommunicationActivityLogDatagrid, DmsDataGrid, Section, SectionTab} from '@dms/shared';

import type {QueryFilterObject} from 'features/eag-grid';

import {useWorkshopUrl} from '../../../../hooks/useWorkshopUrl';

export function ActivityLogs() {
  const {serviceCaseId} = useWorkshopUrl();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {serviceCaseId}]),
    [serviceCaseId]
  );

  const emailActivityLogQueryModifier = useCallback(
    (filter: QueryFilterObject) => ({...filter, recordId: serviceCaseId, customerId: undefined}),
    [serviceCaseId]
  );

  const tabs: SectionTab[] = [
    {
      content: (
        <Card
          title={i18n.t('general.labels.activityLogs')}
          isFullHeight
          key="activity-logs-datagrid"
        >
          <DmsDataGrid
            gridCode="activity-log-service-case"
            queryModifier={queryModifier}
            data-testid={testIds.workshop.serviceCaseDetail('activityLogs')}
          />
        </Card>
      ),
      queryId: 'activityLogs',
      title: i18n.t('general.labels.activityLogs'),
    },
    {
      content: (
        <Card
          title={i18n.t('general.labels.emailActivityLogs')}
          isFullHeight
          key="email-activity-logs-datagrid"
        >
          <CommunicationActivityLogDatagrid
            queryModifier={emailActivityLogQueryModifier}
            presetInstanceId="service-case-email-activity-logs"
            data-testid={testIds.workshop.serviceCaseDetail('emailActivityLogs')}
          />
        </Card>
      ),
      title: i18n.t('general.labels.emailActivityLogs'),
      queryId: 'service-case-email-activity-log',
    },
  ];

  return <Section tabs={tabs} isFullHeight />;
}
